import { extractPhoneNumber } from '../ReviewCombinedPersonalInformation/util';

export const contactInfoLine1 = customer => {
  const { residentialAddress } = customer || {};

  const { street1, street2, zip, city, state } = residentialAddress || {};

  return [street1, street2, city, state, zip].filter(item => item).join(' / ');
};
export const contactInfoLine2 = customer => {
  const { primaryEmailAddress: emailAddress, phones } = customer || {};

  const phoneNumber = extractPhoneNumber(phones);

  return [emailAddress, phoneNumber].filter(item => item).join(' / ');
};
